import { PauseCircleIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Card, CardContent } from '@/components'
import { hasTrialEnded, useAccount, useIsTrialAccount } from '@/modules/account'
import { SelectPlanForm } from '@/modules/auth'
import { BaseError } from './BaseError'

const INACTIVE_PLAN_COPY = {
  title: 'Your plan is inactive',
  description:
    "It looks like you don't have an active plan to access the application.",
}

const TRIAL_ENDED_COPY = {
  title: 'Your trial has ended',
  description: 'Your case and results are kept. Pick a plan to continue.',
}

const Forbidden = forwardRef<HTMLDivElement>((props, ref) => {
  const isTrial = useIsTrialAccount()
  const copy = hasTrialEnded(useAccount())
    ? TRIAL_ENDED_COPY
    : INACTIVE_PLAN_COPY

  return (
    <>
      <BaseError
        title={copy.title}
        description={copy.description}
        icon={PauseCircleIcon}
        withLogout
        {...props}
        ref={ref}
      >
        {!isTrial && (
          <Card className="w-md max-w-full lg:shrink-0 mx-auto lg:mx-0 text-left">
            <CardContent className="px-4 sm:px-6 md:px-7 lg:px-6 xl:px-7 p-6">
              <SelectPlanForm />
            </CardContent>
          </Card>
        )}
      </BaseError>
      {isTrial && (
        <div className="mx-auto w-full max-w-6xl px-8 pb-8">
          <SelectPlanForm />
        </div>
      )}
    </>
  )
})

Forbidden.displayName = 'Forbidden'

export { Forbidden }
